import React, { useContext, useState, useEffect, useRef } from "react";
import BodyClassName from "react-body-classname";
import { SurveyContext } from "../../store/survey-context";
import * as Survey from "survey-react";
import * as widgets from "surveyjs-widgets";
import PlacesWrapper from "../../components/placesWrapper/placesWrapper";
import ProductSelection from "../../components/productSelection/productSelection";
import { useTranslation } from "react-i18next";
//import { useHistory } from "react-router";
// events
import { enableNextButton } from "./events/utils.js";
import onValueChanged from "./events/onValueChanged";
import onValueChanging from "./events/onValueChanging";
import onAfterRenderQuestion from "./events/onAfterRenderQuestion";
import onUpdateQuestionCssClasses from "./events/onUpdateQuestionCssClasses";

import showdown from "showdown";
import "survey-react/survey.css";
import "select2/dist/css/select2.css";
import "nouislider/distribute/nouislider.css";
//import "easy-autocomplete/dist/easy-autocomplete.css";
import "./style.scss";
import $ from "jquery";
import {
  calculateProgress,
  crmValueToSurveyPage,
  calculateTotalProgress,
  setAppBackground,
} from "../../utils";
// widgets
import "nouislider";
import "select2/dist/js/select2.js";

import { surveyModel } from "../../mock/survey-questions.js";

// import Loader from "../../components/loader/loader";
import MarkForLater from "../../components/markForLater/MarkForLater";
import AppHeader from "../../components/appHeader/appHeader";
import SplashScreen from "../../components/splashScreen/splashScreen";
import MainNav from "../../components/navigation/nav";

import MacallanAPI from "../../api/macallan";
import { Loader } from "@googlemaps/js-api-loader";

window["$"] = window["jQuery"] = $;
//require("easy-autocomplete");
Survey.settings.titleTags.question = "h1";
Survey.StylesManager.applyTheme("default");
//widgets.autocomplete(Survey, $);
widgets.select2(Survey, $);
widgets.select2tagbox(Survey, $);
widgets.nouislider(Survey);

// change some default SurveyJS
const defaultThemeColors = Survey.StylesManager.ThemeColors["default"];
//console.log(defaultThemeColors);
defaultThemeColors["$header-background-color"] = "transparent";
defaultThemeColors["$body-container-background-color"] = "transparent";

defaultThemeColors["$main-color"] = "#fff";
defaultThemeColors["$main-hover-color"] = "lightblue";
defaultThemeColors["$body-background-color"] = "transparent";
defaultThemeColors["$inputs-background-color"] = "transparent";
defaultThemeColors["$text-color"] = "#fff";
defaultThemeColors["$text-input-color"] = "#000";
defaultThemeColors["$header-color"] = "#000";
defaultThemeColors["$border-color"] = "transparent";

defaultThemeColors["$disable-color"] = "#dbdbdb";
defaultThemeColors["$progress-text-color"] = "#9d9d9d";
defaultThemeColors["$disabled-label-color"] = "rgba(64, 64, 64, 0.5)";
defaultThemeColors["$slider-color"] = "white";
defaultThemeColors["$disabled-switch-color"] = "#9f9f9f";
defaultThemeColors["$disabled-slider-color"] = "#cfcfcf";

Survey.StylesManager.applyTheme("mtc-theme");

// clear input run by "trigger" in surveyjs
const clearInput = function (name) {
  const survey = this.survey;
  survey.clearValue(name);
};
// add function to be used in prototype.js
Survey.FunctionFactory.Instance.register("clearInput", clearInput);

// add fields to the survey model pages[X].propertyHash
Survey.Serializer.addProperty("page", "chapter:number");
Survey.Serializer.addProperty("page", "isEasterEgg:boolean");
Survey.Serializer.addProperty("page", "isAnswered:boolean");
Survey.Serializer.addProperty("page", "isMarkedForLater:boolean");
Survey.Serializer.addProperty("page", "background:text");
Survey.Serializer.addProperty("page", "backgroundOpacity:number");
Survey.Serializer.addProperty("page", "preloadBackground:array");
Survey.Serializer.addProperty("question", "customCssClass:text");
Survey.Serializer.addProperty("page", "crmId:text");
Survey.Serializer.addProperty("question", "crmId:array");
Survey.Serializer.addProperty("page", "disabledMarkForLater:boolean");
Survey.Serializer.addProperty("page", "cardinalities:array");

Survey.JsonObject.metaData.addProperty("itemvalue", { name: "collection" });

//var questionSaving = true;

// MTC survey specifc classes
const myCss = {
  root: "sv_mtc fade-in",
  navigationButton: "btn",
  navigation: {
    next: "btn--primary text-uppercase",
    prev: "btn--link text-uppercase",
    complete: "btn--primary text-uppercase",
  },
  footer: "flex-center survey-buttons",
};
const converterHash = {};
const converter = new showdown.Converter();

export default function Questionnaire() {
  const context = useContext(SurveyContext);
  const [chapterUnlocked, setChapterUnlocked] = useState(1);
  const [lastVisitedPage, setLastVisitedPage] = useState(-1);
  const [currentChapterProgress, setCurrentChapterProgress] = useState(0);

  const { t, ready, i18n } = useTranslation(["common", "survey"], {
    useSuspense: false,
  });
  const api = new MacallanAPI(context.accessToken);

  //const history = useHistory();
  const {
    toggleSurvey,
    setSurveyJs,
    userProfile,
    macallanWhiskies,
    markedForLater,
    setChapterProgress,
  } = context;

  useEffect(() => {
    const loader = new Loader({
      apiKey: "AIzaSyBuM5X7hznH80oH3X_NSOOUKOWoqCa0Q10",
      version: "weekly",
      libraries: ["places"],
      language: i18n.resolvedLanguage,
    });

    loader.load().then(() => {
      // add a custom widget to use autocomplete from Google Maps Places
      //if (Survey.CustomWidgetCollection.Instance.widgetsActivatedBy.places === undefined) {
      Survey.CustomWidgetCollection.Instance.addCustomWidget({
        name: "places",
        isFit: (question) => {
          return question.name === "city" || question.name === "other_city";
        },
        render: (question) => {
          return <PlacesWrapper question={question} value={question.value} />;
        },
      });
      //}
    });

    Survey.CustomWidgetCollection.Instance.addCustomWidget({
      name: "product_selection",
      isFit: (question) => {
        return (
          [
            "macallan_experienced",
            "macallan_regularly",
            "macallan_own",
            "macallan_like_to_own",
          ].indexOf(question.name) !== -1
        );
      },
      render: (question) => {
        return <ProductSelection question={question} />;
      },
    });
    /*
    return function cleanup() {
      if (loader) {
        Loader.instance = null;
        delete window.google;
        loader.deleteScript();
      }
    }
    */
  }, [i18n.resolvedLanguage]);

  useEffect(() => {
    return function cleanup() {
      toggleSurvey(false);
      setSurveyJs(null);
      //i18n.off("languageChanged");
    };
  }, [toggleSurvey, setSurveyJs]);

  const hasFirstRun = useRef(false);

  useEffect(() => {
    if (ready && !hasFirstRun.current) {
      hasFirstRun.current = true;
      // Fill in user answers and set marked for later
      const updateSurveyState = (survey) => {
        // get Macallan whiskies and populate choices in the questions
        if (macallanWhiskies) {
          const macallanWhiskiesNames = [];
          const macallanWhiskiesCrmIds = [];
          macallanWhiskies.forEach((item) => {
            macallanWhiskiesNames.push({
              text: item.label,
              value: item.label,
              collection: item.collection,
            });
            macallanWhiskiesCrmIds.push(item.productCode);
          });

          // questions with list of Macallan whiskies
          const whiskyPages = ["q_3_10", "q_3_12", "q_3_13", "q_3_14"];
          survey.pages.forEach((page) => {
            if (whiskyPages.indexOf(page.name) !== -1) {
              const index = page.questions.length > 1 ? 1 : 0;
              page.questions[index].choices = macallanWhiskiesNames;
              page.questions[index].crmId = macallanWhiskiesCrmIds;
            }
          });
        }
        // fill in user answers from API
        const answers = userProfile?.answers;

        if (answers) {
          const pages = survey.pages;

          //console.log(answers);
          // find each question from "answers" and select the values

          pages.forEach((page) => {
            if (page.crmId && typeof answers[page.crmId] !== "undefined") {
              const answer = answers[page.crmId];
              crmValueToSurveyPage(page, answer, survey);
              page.isAnswered = true;
            }
          });

          // marked for later property
          if (markedForLater) {
            const pages = survey.pages;
            pages.forEach((page) => {
              if (page.crmId && markedForLater.indexOf(page.crmId) !== -1) {
                page.isMarkedForLater = true;
              }
            });
          }
          // recalculate whole progress based on current survey object state
          const chaptersCount = 4;
          let chapterUnlocked = 1;
          for (let i = 1; i <= chaptersCount; i++) {
            let progress = calculateProgress(i, survey);
            setChapterProgress(i, progress);

            // include Marked for later questions - so the next chapters could be unlocked
            progress = calculateProgress(i, survey, true);
            if (progress === 100) {
              chapterUnlocked = i + 1;
            } else if (chapterUnlocked < i && progress > 0) {
              chapterUnlocked = i;
            }
          }

          if (chapterUnlocked > 1) setChapterUnlocked(chapterUnlocked);
        }
      };

      const surveyMTC = new Survey.Model(surveyModel(t));
      //window.surveyMTC = surveyMTC;
      surveyMTC.isNextButtonClicked = false;
      surveyMTC.isPrevButtonClicked = false;
      setSurveyJs(surveyMTC);

      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

      if (process.env.REACT_APP_DEBUG === "1") {
        const url = new URLSearchParams(window.location.search);
        const page = url.get("page");
        if (page > 0) {
          setTimeout(() => {
            toggleSurvey(true);
            surveyMTC.ignoreValidation = true;
            const targetPage = surveyMTC.pages[page - 1];
            targetPage.visible = true;
            const visibleIf = targetPage.visibleIf;
            targetPage.visibleIf = "";
            surveyMTC.currentPage = targetPage;
            surveyMTC.ignoreValidation = false;
            targetPage.visibleIf = visibleIf;
          }, 0);
        }
      }

      // update state (answers)
      updateSurveyState(surveyMTC);
    }
  }, [
    ready,
    toggleSurvey,
    setSurveyJs,
    t,
    userProfile,
    macallanWhiskies,
    markedForLater,
    setChapterProgress,
  ]);

  const onTextMarkdown = (survey, options) => {
    let str = converterHash[options.text];
    if (!str) {
      //convert the markdown text to html
      str = converter.makeHtml(options.text);
      //remove root paragraphs <p></p> if not <img> inside
      if (str.indexOf("<img") === -1) {
        str = str.substring(3);
        str = str.substring(0, str.length - 4);
      }
      //set html
      converterHash[options.text] = str;
    }
    options.html = str;
  };

  /*
  shouldComponentUpdate(nextProps, nextState) {
    // no need to re-render after internal state change as it will be triggered by toggleSurvey anyway (if needed)
    if (
      this.state.currentChapterProgress !== nextState.currentChapterProgress
    ) {
      return true;
    }
    return false;
  }
  */

  const onCurrentPageChanged = (survey, options) => {
    if (lastVisitedPage !== -1 && survey.isOnMarkedForLaterList) {
      setLastVisitedPage(-1);
    }

    // change background - if defined in survey config
    const background = options.newCurrentPage?.background;
    if (background) {
      const backgroundOpacity = options.newCurrentPage?.backgroundOpacity;
      const preloadBackground = options.newCurrentPage?.preloadBackground;
      setAppBackground(background, backgroundOpacity ?? 0.8);
      if (preloadBackground) {
        preloadBackground.forEach((b) => {
          const img = new Image();
          img.src = `/backgrounds/${b}`;
        });
      }
    }

    // skip Easter egg on going back
    if (options.isPrevPage && options.newCurrentPage.isEasterEgg) {
      survey.prevPage();
      return;
    }

    const el = survey.pages.findIndex(
      (element) => element.name === survey.currentPage.name
    );

    // calculate progress for the last chapter - based on answered questions
    const currentChapter = options.newCurrentPage?.chapter;

    if (currentChapter && currentChapter !== context.currentChapterNumber) {
      context.setCurrentChapter(options.newCurrentPage?.chapter);
    }

    // GTM - view current page. Get the index from
    const qOld = options.oldCurrentPage?.questions[0];
    // const qNew = options.newCurrentPage?.questions[0];
    const step = survey.pages.findIndex(
      (element) => element.name === options.oldCurrentPage?.name
    );
    if (qOld) {
      window.dataLayer?.push({
        event: "mtcExpScreen",
        screen: qOld.title,
        step: step + 6,
      });
    }

    if (
      survey.isNextButtonClicked &&
      options.isNextPage &&
      !survey.ignoreValidation
    ) {
      // mark previous question as answered (just this easy check for start) - there will be problems with navigation using Nav page - we might have unanswred page marked...
      options.oldCurrentPage.isAnswered = true;
      context.markedForLater = context.removeMarkedForLater(
        options.oldCurrentPage.crmId
      );
      options.oldCurrentPage.isMarkedForLater = false;
      let answers = "";
      if (!options.oldCurrentPage.isEasterEgg) {
        // call API to save the answer
        if (context.accessToken) {
          // TODO send to the API only if question has been changed
          const chapterOnePercentageComplete = calculateProgress(1, survey);
          const chapterTwoPercentageComplete = calculateProgress(2, survey);
          const chapterThreePercentageComplete = calculateProgress(3, survey);
          const chapterFourPercentageComplete = calculateProgress(4, survey);

          const overallPercentageComplete = calculateTotalProgress(survey);
          const progress = {
            overallPercentageComplete,
            chapterOnePercentageComplete,
            chapterTwoPercentageComplete,
            chapterThreePercentageComplete,
            chapterFourPercentageComplete,
          };

          context.userProfile.percentageCompletionValues.overall =
            overallPercentageComplete;

          api
            .setAnswer(options.oldCurrentPage, progress, context.markedForLater)
            .then((answer) => {
              // save the answer in context
              if (options.oldCurrentPage.crmId) {
                context.userProfile.answers[options.oldCurrentPage.crmId] =
                  answer;
              }

              context.userProfile.percentageCompletionValues.overall =
                overallPercentageComplete;
              context.userProfile.percentageCompletionValues.chapterOne =
                chapterOnePercentageComplete;
              context.userProfile.percentageCompletionValues.chapterTwo =
                chapterTwoPercentageComplete;
              context.userProfile.percentageCompletionValues.chapterThree =
                chapterThreePercentageComplete;
              context.userProfile.percentageCompletionValues.chapterFour =
                chapterFourPercentageComplete;
            })
            .catch((e) => {
              context.setError(true);
              console.log(e);
            })
            .finally(() => {
              if (api.accessToken !== context.accessToken)
                context.setAccessToken(api.accessToken);
            });
        }

        options.oldCurrentPage.questions.forEach(function (q) {
          if (q.selectedItem) {
            answers += q.selectedItem.text;
          } else if (q.selectedItems) {
            q.selectedItems.forEach(function (item) {
              if (!item) return;
              answers += item.text + "; ";
            });
          } else if (q.value !== null && q.value !== undefined) {
            answers += q.value;
          }

          if (q.comment) answers += ` ${q.comment}`;
        });
        if (qOld) {
          // GTM - log the answer
          window.dataLayer?.push({
            event: "mtcExpQuestion",
            question: qOld.title,
            response: answers,
          });
        }
      }
    }

    // question marked as not answered - because "Mark for later" clicked
    if (options.isNextPage && survey.ignoreValidation) {
      options.oldCurrentPage.isAnswered = false;
      if (qOld) {
        window.dataLayer?.push({
          event: "mtcExpMark",
          screen: qOld.title,
        });
      }
    }

    // next or MFL clicked on a last question of a chapter - show the navigation page
    if (
      (survey.isNextButtonClicked ||
        (options.isNextPage && survey.ignoreValidation)) &&
      options.newCurrentPage?.chapter > options.oldCurrentPage?.chapter &&
      !survey.isOnMarkedForLaterList
    ) {
      // unlock next chapter
      /*
      context.setChapterProgress(
        currentChapter - 1,
        calculateProgress(currentChapter - 1)
      );
      */
      if (chapterUnlocked < currentChapter) setChapterUnlocked(currentChapter);
      setLastVisitedPage(-1);
      context.toggleSurvey(false);
    } else if (!context.showNav && !survey.isOnMarkedForLaterList) {
      setLastVisitedPage(el);
    }

    // CHAPTER ONE
    let currentChapterProgress = 0;
    if (currentChapter === 1) {
      const chapterOneArray = survey.pages.filter(
        (element) => element.chapter === 1 && element.isVisible
      );
      const chapterOneCount = parseFloat(chapterOneArray.length);
      const chapterOneQuestionIndex = chapterOneArray.findIndex(
        (element) => element.name === options.newCurrentPage?.name
      );

      currentChapterProgress =
        (chapterOneQuestionIndex / chapterOneCount) * 100;
      //context.setCurrentChapterProgress(chapterOneProgress);
    }

    if (currentChapter === 2) {
      const chapterTwoArray = survey.pages.filter(
        (element) => element.chapter === 2 && element.isVisible
      );
      const chapterTwoCount = parseFloat(chapterTwoArray.length);
      const chapterTwoQuestionIndex = chapterTwoArray.findIndex(
        (element) => element.name === options.newCurrentPage?.name
      );

      currentChapterProgress =
        (chapterTwoQuestionIndex / chapterTwoCount) * 100;
      //context.setCurrentChapterProgress(chapterTwoProgress);
    }

    if (currentChapter === 3) {
      const chapterThreeArray = survey.pages.filter(
        (element) => element.chapter === 3 && element.isVisible
      );
      const chapterThreeCount = parseFloat(chapterThreeArray.length);
      const chapterThreeQuestionIndex = chapterThreeArray.findIndex(
        (element) => element.name === options.newCurrentPage?.name
      );

      currentChapterProgress =
        (chapterThreeQuestionIndex / chapterThreeCount) * 100;
      //context.setCurrentChapterProgress(chapterThreeProgress);
    }

    if (currentChapter === 4) {
      const chapterFourArray = survey.pages.filter(
        (element) => element.chapter === 4 && element.isVisible
      );
      const chapterFourCount = parseFloat(chapterFourArray.length);
      const chapterFourQuestionIndex = chapterFourArray.findIndex(
        (element) => element.name === options.newCurrentPage?.name
      );

      currentChapterProgress =
        (chapterFourQuestionIndex / (chapterFourCount - 1)) * 100;
      //context.setCurrentChapterProgress(chapterFourProgress);
    }

    setCurrentChapterProgress(currentChapterProgress);

    if (options.isNextPage) {
      context.setChapterProgress(
        currentChapter,
        calculateProgress(currentChapter, survey)
      );
    }

    if (survey.isLastPage && options.isNextPage) {
      context.toggleSurvey(false);
      options.allowChanging = false;
    }

    if (options.newCurrentPage) {
      enableNextButton(!survey.isCurrentPageHasErrors);
      options.newCurrentPage.clearErrors();
    }

    // if we're in the context of "mark for later list" and
    // - verify if there is any "previous" question on the list
    // - when "next" or "mfl" was clicked - check if we have any next question on a list - if not: either return to MFL list if we have still any items there or go to the main navigation when thelist is empty
    //

    const prevBtn = document.querySelector(".survey-buttons .btn--link");
    if (prevBtn) {
      prevBtn.style.display = survey.isOnMarkedForLaterList ? "none" : "block";
    }

    if (
      survey.isOnMarkedForLaterList &&
      (survey.isNextButtonClicked ||
        (options.isNextPage && survey.ignoreValidation))
    ) {
      survey.ignoreValidation = false;
      //console.log(options.oldCurrentPage.crmId, options.oldCurrentPage.name);
      const sorted = [];
      let oldPageIndex;

      context.markedForLater.forEach((crmId) => {
        const page = survey.pages.find((item) => item.crmId === crmId);
        if (!page || !page.isVisible) return;
        const pageIndex = survey.pages.findIndex(
          (item) => item.crmId === crmId
        );
        sorted[pageIndex] = page;

        if (crmId === options.oldCurrentPage.crmId) {
          oldPageIndex = pageIndex;
        }
      });

      if (survey.isNextButtonClicked) {
        oldPageIndex = survey.pages.findIndex(
          (item) => item.crmId === options.oldCurrentPage.crmId
        );
      }

      if (oldPageIndex >= 0) {
        if (options.isNextPage) {
          let nextMFLPage;
          // find the next question on a MFL list and go there if exists
          sorted.forEach((s, i) => {
            if (!nextMFLPage && i > oldPageIndex) {
              nextMFLPage = s;
            }
          });

          if (survey.isNextButtonClicked) survey.isNextButtonClicked = false;

          if (nextMFLPage) {
            survey.currentPage = nextMFLPage;
          } else {
            context.toggleSurvey(false);
            setLastVisitedPage(-1);
            // go to MFL list or main nav
          }
        }
      }
    }

    if (survey.isNextButtonClicked) survey.isNextButtonClicked = false;
  };

  const onCurrentPageChanging = (survey, options) => {
    // scroll to top
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, 10);

    // recover the question from user profile - to be sure we have the same as in CRM
    if (context.userProfile?.answers && survey.isPrevButtonClicked) {
      const page = options.oldCurrentPage;
      if (page) {
        const crmAnswer = context.userProfile.answers[page.crmId];
        if (crmAnswer !== undefined) {
          crmValueToSurveyPage(page, crmAnswer, survey);
        } else {
          // clear the questions on current page - because there was no answer
          page.questions.forEach(function (q) {
            survey.setValue(q.name, null);
          });
        }
      }
    }

    survey.isPrevButtonClicked = false;
  };

  const onAfterRenderSurvey = (survey) => {
    // remove survey-buttons if already existed
    const surveyButtons = document.querySelector(".survey-buttons");
    if (surveyButtons) {
      surveyButtons.remove();
    }

    // use custom navigation (unluckily, because original navigation has <input type="button">) s
    const container = document.querySelector(".sv_container");
    const nextHtml = `<button class="btn--next link text-uppercase" disabled><span>
     ${t("survey.common.next", { ns: "survey" })}</span>
     <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
       <path d="M6.99997 8.34682e-07L-2.70446e-05 7L6.99997 14L8.36108 12.6389L2.7222 7L8.36109 1.36111L6.99997 8.34682e-07Z" fill="white"/>
     </svg>
     </button>`;
    const prevHtml = `<button type="button" class="btn--prev link text-uppercase">
     <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
       <path d="M6.99997 8.34682e-07L-2.70446e-05 7L6.99997 14L8.36108 12.6389L2.7222 7L8.36109 1.36111L6.99997 8.34682e-07Z" fill="white"/>
     </svg>
     <span>${t("survey.common.previous", { ns: "survey" })}</span>
     </button>`;

    container.insertAdjacentHTML(
      "beforebegin",
      `<div class="flex-center survey-buttons">${prevHtml}${nextHtml}</div>`
    );

    /*
    const buttonsPlacement = document.querySelector(".sv_q_instructions");
    buttonsPlacement.insertAdjacentHTML(
      "beforebegin",
      `<div class="survey-buttons">${prevHtml}${nextHtml}</div>`
    );
    */

    const nextBtn = document.querySelector(".survey-buttons .btn--next");
    const prevBtn = document.querySelector(".survey-buttons .btn--prev");

    nextBtn?.addEventListener("click", () => {
      survey.isNextButtonClicked = true;
      if (!survey.nextPage()) {
        survey.isNextButtonClicked = false;
      }
    });
    prevBtn?.addEventListener("click", () => {
      // if we're on a first question in a chapter - return to the navigation page
      if (
        survey.currentPage.name === "q_1_1" ||
        survey.currentPage.name === "q_2_1" ||
        survey.currentPage.name === "q_3_1" ||
        survey.currentPage.name === "q_4_1"
      ) {
        context.toggleSurvey(false);
        setLastVisitedPage(-1);
      } else {
        survey.isPrevButtonClicked = true;
        survey.prevPage();
      }
    });

    // enable Next button if returned from other page
    enableNextButton(!survey.isCurrentPageHasErrors);
    survey.currentPage.clearErrors();
  };

  const onAfterRenderPage = (survey, options) => {
    const stepNew =
      survey.pages.findIndex((element) => element.name === options.page?.name) +
      1;
    // state change for Hotjar
    setTimeout(() => {
      if (
        window.hj &&
        !context.showNav &&
        !context.showSplash &&
        !context.isLoading &&
        !document.querySelector(".navigation")
      ) {
        window.hj("stateChange", "questionnaire/" + stepNew);
      }
      // change the current page - for easier debugging
      if (process.env.REACT_APP_DEBUG === "1") {
        window.history.replaceState(null, document.title, `?page=${stepNew}`);
      }

      // enable Next button if returned from other page
      enableNextButton(!survey.isCurrentPageHasErrors);
      survey.currentPage.clearErrors();
    }, 0);
  };

  const { showSurvey, showNav, showSplash, survey } = context;

  if (!survey || !ready) return null;

  return (
    <>
      <BodyClassName className="body-survey" />
      {showNav && (
        <MainNav
          chapterUnlocked={chapterUnlocked}
          lastVisitedPage={lastVisitedPage}
        />
      )}
      {showSurvey && (
        <>
          <AppHeader currentChapterProgress={currentChapterProgress} />
          {showSplash ? (
            <SplashScreen setLastVisitedPage={setLastVisitedPage} />
          ) : (
            <span></span>
          )}
        </>
      )}

      <div
        className="survey"
        style={{ display: showSurvey && !showSplash ? "block" : "none" }}
      >
        <Survey.Survey
          model={survey}
          onAfterRenderPage={onAfterRenderPage}
          onAfterRenderQuestion={(s, q) => onAfterRenderQuestion(s, q, t)}
          onAfterRenderSurvey={onAfterRenderSurvey}
          onValueChanged={onValueChanged}
          onValueChanging={onValueChanging}
          onCurrentPageChanged={onCurrentPageChanged}
          onCurrentPageChanging={onCurrentPageChanging}
          onUpdateQuestionCssClasses={onUpdateQuestionCssClasses}
          onTextMarkdown={onTextMarkdown}
          showQuestionNumbers="false"
          requiredText=""
          completeText={t("survey.common.see_your_journey", { ns: "survey" })}
          css={myCss}
          currentPage={survey.currentPage}
          checkErrorsMode="onValueChanged"
          textUpdateMode="onTyping"
          focusFirstQuestionAutomatic={false}
          focusFirstQuestion={false}
          focusOnFirstError={false}
          showNavigationButtons={false}
        />
        <MarkForLater />
      </div>
    </>
  );
}
